// extracted by mini-css-extract-plugin
export var chat = "style-module--chat--2e5ed";
export var container = "style-module--container--f0b1e";
export var content = "style-module--content--b066b";
export var name = "style-module--name--214ca";
export var text = "style-module--text--3a062";
export var title = "style-module--title--69b70";
export var videoBg = "style-module--video-bg--8775c";
export var videoFrame = "style-module--video-frame--3e0cb";
export var wrap = "style-module--wrap--a53f2";